import { css } from 'lit';


export const citationTeaserOnDarkStyles = css`
    :host {
      --_citation-teaser-color: var(--sbkCitationTeaserColorBgColorNeutral);
       }
`;
